// src/api/client.js
import ky from "ky";
import EventBus from "../../events/EventBus";

const extranetClient = ky.extend({
    prefixUrl: process.env.REACT_APP_EXTRANET_API,
    timeout: false,
    hooks: {
        beforeRequest: [
            request => {
                // Header personnalisé uniquement
                request.headers.set("X-Requested-With", "ky");
                // Ne pas toucher à Content-Type :
                // ky gère automatiquement JSON vs FormData
            }
        ],
        beforeError: [
            error => {
                const { response } = error;
                if (response && response.body) {
                    error.name = "GitHubError";
                    error.message = `${response.body.message} (${response.status})`;
                }
                return error;
            }
        ],
        beforeRetry: [
            async ({ request }) => {
                const token = await ky("https://localhost/refresh-token");
                request.headers.set("Authorization", `token ${token}`);
            }
        ],
        afterResponse: [
            (_request, _options, response) => {
                if (response.status === 401) {
                    EventBus.dispatch("token-expired");
                }
                // Re-crée la Response pour propager le body tel quel
                return new Response(response.body, { status: response.status });
            }
        ]
    }
});

export default extranetClient;
